var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectpk"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('pkcs8upload',{on:{"PKCS8UploadEvent":_vm.newfiles,"cancelEvent":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }